import {Link, NavLink} from 'react-router-dom';
import { W_Menu } from '../assets/icones/icones';
import '../../src/components/assets/css/home-aisde.css';
import React, {Fragment,useEffect} from 'react';
import {Skeleton} from "@mui/material";
const HomeAside = (props) => {

    const  menuHandler = () => {
        const menu = document.querySelector('.home-aside-container')
        menu.classList.toggle('mob-menu-act')
    }
  return (
    <Fragment>
        <div className='home-aside-container menu-sidebarcat-mob' style={{display:"none"}}>
            <h2 className='flexRowStartCenter'>
                <W_Menu />
                دسته‌بندی
            </h2>
            <button onClick={menuHandler}>
                <svg width='1.25rem' height='1.25rem' fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
            </button>
            <ul>





                {

                    props.data_category_box.length > 0 ?  (
                    <Fragment>

                        <ul className={"cat-sidebar-items aaaa"}>

                            <li onClick={menuHandler} >
                                <Link to={"/"}   className={'cat-side-bar-item'} >
                                    <span>همه دوره ها</span>
                                </Link>
                            </li>

                            { props.data_category_box.map((item, index) => {
                                return (
                                    <li  key={index} onClick={menuHandler}>
                                        <Link to={"/course-category/" + item.id_post}   className={'cat-side-bar-item'} >
                                            <span>{item.title_post}</span>
                                        </Link>
                                    </li>
                                )
                            })}
                        </ul>

                    </Fragment>

                ) : (<Fragment>
                    <ul className={"cat-sidebar-items bbbb"}>

                        <li onClick={menuHandler}>
                            <Link to={"/"}   className={'cat-side-bar-item'} >
                                <span>همه دوره ها</span>
                            </Link>
                        </li>

                        {props.data_category_box.map((item, index) => {
                            return (
                                <li key={index} onClick={menuHandler}>
                                    <Link to={"/course-category/" + item.id_post}  className={'cat-side-bar-item'} >
                                        <span>{item.title_post}</span>
                                    </Link>
                                </li>
                            )
                        })}
                    </ul>
                </Fragment>)

                }





            </ul>
        </div>
    </Fragment>
  );
}

export default HomeAside;